import OstroDynamicContent from 'app/components/OstroDynamicContent';
import UnreadMessagesBadge from 'app/components/UnreadMessagesBadge';
import RightArrowIcon from 'app/components/icons/RightArrowIcon';
import useFeatureFlags from 'app/hooks/useFeatureFlags';
import React from 'react';
import { Link } from 'react-router-dom';

export default function SingleCTA({
  imgSrc,
  imgAlt,
  title,
  description,
  caption,
  link,
  unreadMessageCount,
  onClick,
  target,
}: {
  imgSrc?: string;
  imgAlt?: string;
  title?: string;
  description?: string;
  caption?: string;
  link: string;
  unreadMessageCount: number;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  target?: string;
}) {
  const featureFlags = useFeatureFlags();
  const fontSize = featureFlags.uiRefreshFontSizeIncrease ? 'sm' : 'xs';

  return (
    <Link
      to={link}
      className="flex items-center gap-4 bg-white rounded-2xl px-3 py-4 text-left w-full"
      onClick={onClick}
      target={target}
    >
      <div className="w-6 relative shrink-0 self-start">
        <img
          className="block w-6 h-6"
          src={imgSrc}
          alt={imgSrc ? imgAlt : undefined}
        />
        {unreadMessageCount > 0 && (
          <UnreadMessagesBadge
            count={unreadMessageCount}
            size="sm"
            className="top-[-5px] right-[-5px]"
          />
        )}
      </div>
      <div className="grow">
        <OstroDynamicContent content={title} />
        {description && (
          <OstroDynamicContent
            content={description}
            className={`[&_p]:(text-${fontSize} text-typography-copy) [&_p:last-child]:(mb-0) text-typography-copy text-${fontSize}`}
          />
        )}
        {!!caption && (
          <div className="mt-2 py-1 px-2 text-[10px] bg-brand-primary rounded-2xl whitespace-nowrap inline-block">
            {caption}
          </div>
        )}
      </div>
      <div className="w-6 self-start">
        <RightArrowIcon className="w-6 h-6 flex-1" />
      </div>
    </Link>
  );
}
